/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Bicycle specifications popover (collection / category cards, mobile)
   * Toggles the specs panel when the info button is tapped. Uses event
   * delegation so it works for every product card on the page.
   */
  function closeAllSpecs(except) {
    var open = document.querySelectorAll('.product-grid-item.grid-specs-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('grid-specs-open');
      var t = open[i].querySelector('[data-grid-specs-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('[data-grid-specs-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var card = toggle.closest('.product-grid-item');
      if (!card) return;
      var willOpen = !card.classList.contains('grid-specs-open');
      closeAllSpecs(card);
      card.classList.toggle('grid-specs-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    // Click outside an open panel closes it.
    if (!e.target.closest('[data-grid-specs-panel]')) {
      closeAllSpecs(null);
    }
  });


  /*
   * Quick buy button -> dataLayer "view_item" event.
   * Delegated on document so it works for every .btn-quick-buy on the page,
   * including cards rendered after load.
   */
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;

    var quickBuy = e.target.closest('.btn-quick-buy');
    if (!quickBuy) return;

    // Prices come from Liquid in cents (e.g. 1500000 = $15.000,00).
    var priceCents = parseInt(quickBuy.getAttribute('data-gtm-price'), 10) || 0;
    var compareCents = parseInt(quickBuy.getAttribute('data-gtm-compare-at-price'), 10) || 0;
    var price = priceCents / 100;
    var discount = compareCents > priceCents ? (compareCents - priceCents) / 100 : 0;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: quickBuy.getAttribute('data-gtm-currency') || 'ARS',
        value: price,
        items: [
          {
            item_name: quickBuy.getAttribute('data-gtm-item-name') || '',
            item_id: quickBuy.getAttribute('data-gtm-item-id') || '',
            price: price,
            discount: discount,
            coupon: '',
            item_brand: 'Volta',
            item_category: quickBuy.getAttribute('data-gtm-item-category') || '',
            item_variant: quickBuy.getAttribute('data-gtm-item-variant') || '',
            quantity: 1,
            affiliation: 'Tienda Online'
          }
        ]
      }
    });
  });


  /*
   * Reads the currently selected variant title (e.g. "37 / Negro") from a
   * quick view, joining the chosen options in position order (option1, option2…).
   * Works with radio buttons, swatches and <select> based option pickers.
   */
  function getSelectedVariantTitle(scope) {
    if (!scope) return '';
    var byIndex = {};
    var selectors = scope.querySelectorAll('[data-single-option-selector]');
    for (var i = 0; i < selectors.length; i++) {
      var el = selectors[i];
      var index = el.getAttribute('data-index') || ('option' + (i + 1));
      if (el.tagName === 'SELECT') {
        byIndex[index] = el.value;
      } else if (el.type === 'radio') {
        if (el.checked) byIndex[index] = el.value;
      } else if (el.value) {
        byIndex[index] = el.value;
      }
    }
    var keys = Object.keys(byIndex).sort();
    var parts = [];
    for (var k = 0; k < keys.length; k++) parts.push(byIndex[keys[k]]);
    return parts.join(' / ');
  }


  /*
   * Quick view add-to-cart / buy-it-now -> dataLayer "add_to_cart" event.
   * Same structure as view_item, but item_variant reflects the variant the
   * shopper has selected. Scoped to the quick view via the data-gtm-atc marker.
   */
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;

    var item = e.target.closest('.product__submit__item');
    if (!item) return;

    // Marker present only on the quick view buttons container.
    var ctx = item.closest('[data-gtm-atc]');
    if (!ctx) return;

    // Prices come from Liquid in cents (e.g. 1500000 = $15.000,00).
    var priceCents = parseInt(ctx.getAttribute('data-gtm-price'), 10) || 0;
    var compareCents = parseInt(ctx.getAttribute('data-gtm-compare-at-price'), 10) || 0;
    var price = priceCents / 100;
    var discount = compareCents > priceCents ? (compareCents - priceCents) / 100 : 0;

    var scope = item.closest('[data-quick-view-inner]') || document;
    var selectedVariant = getSelectedVariantTitle(scope) || ctx.getAttribute('data-gtm-item-variant') || '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: ctx.getAttribute('data-gtm-currency') || 'ARS',
        value: price,
        items: [
          {
            item_name: ctx.getAttribute('data-gtm-item-name') || '',
            item_id: ctx.getAttribute('data-gtm-item-id') || '',
            price: price,
            discount: discount,
            coupon: '',
            item_brand: 'Volta',
            item_category: ctx.getAttribute('data-gtm-item-category') || '',
            item_variant: selectedVariant,
            quantity: 1,
            affiliation: 'Tienda Online'
          }
        ]
      }
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
